import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb:flex mb:flex-nowrap flex-wrap" }
const _hoisted_2 = { class: "wallet-Box" }
const _hoisted_3 = ["src"]

import { ref, computed } from 'vue'
import ModalWrapper from '../ModalWrapper.vue'
import { useStore } from '@/store'
import { ConnectAppName } from '@/store/state'
import { ChainType } from '@/libs/everpay-js'
import { ImgConnectAppName } from '@/constants'
import ConnectSection from './ConnectSection.vue'
import ConnectItem from './ConnectItem.vue'
import { formatChainTypeDisplay } from '@/libs/util'
import { permaMessage } from '../Message'
import { initAndHandleEvents } from '@/libs/everpay'
import { useI18n } from 'vue-i18n'
interface Wallets {
  name: ConnectAppName
  chainType: ChainType
  img: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const { t } = useI18n()
const connectVisible = computed(() => store.state.connectModalVisible)
const closeModal = () => {
  store.commit('updateConnectModalVisible', false)
}
const chainTypes = [
  ChainType.ethereum,
  ChainType.arweave
]
const activeChainType = ref(chainTypes[0])
const chooseChainType = (item: ChainType) => {
  activeChainType.value = item
}
const account = computed(() => store.state.account)
const wallets:Wallets[] = [
  window.imToken
    ? {
        name: ConnectAppName.imToken,
        chainType: ChainType.ethereum,
        img: ImgConnectAppName[ConnectAppName.imToken]
      }
    : {
        name: ConnectAppName.MetaMask,
        chainType: ChainType.ethereum,
        img: ImgConnectAppName[ConnectAppName.MetaMask]
      },
  {
    name: ConnectAppName.CoinbaseWallet,
    chainType: ChainType.ethereum,
    img: ImgConnectAppName[ConnectAppName.CoinbaseWallet]
  },
  {
    name: ConnectAppName.WalletConnect,
    chainType: ChainType.ethereum,
    img: ImgConnectAppName[ConnectAppName.WalletConnect]
  },
  {
    name: ConnectAppName.BitKeep,
    chainType: ChainType.ethereum,
    img: ImgConnectAppName[ConnectAppName.BitKeep]
  },
  {
    name: ConnectAppName.HuobiWallet,
    chainType: ChainType.ethereum,
    img: ImgConnectAppName[ConnectAppName.HuobiWallet]
  },
  {
    name: ConnectAppName.Safeheron,
    chainType: ChainType.ethereum,
    img: ImgConnectAppName[ConnectAppName.Safeheron]
  },
  {
    name: ConnectAppName.ArConnect,
    chainType: ChainType.arweave,
    img: ImgConnectAppName[ConnectAppName.ArConnect]
  },
  {
    name: ConnectAppName.BitKeep,
    chainType: ChainType.arweave,
    img: ImgConnectAppName[ConnectAppName.BitKeep]
  },
  {
    name: ConnectAppName.Finnie,
    chainType: ChainType.arweave,
    img: ImgConnectAppName[ConnectAppName.Finnie]
  },
  {
    name: ConnectAppName.MathWallet,
    chainType: ChainType.arweave,
    img: ImgConnectAppName[ConnectAppName.MathWallet]
  }
]
const activeWalletName = ref(ConnectAppName.MetaMask)
const walletsArr = computed(() => {
  const result: any[] = []
  let itemArr: any[] = []
  const displayWallets = wallets.filter(wallet => wallet.chainType === activeChainType.value)
  displayWallets.forEach((wallet, index) => {
    if (itemArr.length < 2) {
      itemArr.push(wallet)
    }

    if (itemArr.length === 2 || displayWallets.length - 1 === index) {
      result.push(itemArr)
      itemArr = []
    }
  })
  return result
})
const connectWallet = async (wallet: Wallets) => {
  if (store.state.connectAppName === wallet.name && account.value !== '') {
    closeModal()
    return
  }
  store.dispatch('resetAccount')
  activeWalletName.value = wallet.name
  // 先更新，避免不一致
  store.commit('updateConnectAppName', wallet.name)
  closeModal()
  store.commit('updateConnectingModalVisible', true)
  await initAndHandleEvents({
    store,
    t,
    accChainType: wallet.chainType
  })
  if (store.state.account) {
    permaMessage({
      showClose: true,
      message: t('connect_success'),
      type: 'success'
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalWrapper, {
    visible: _unref(connectVisible),
    title: _unref(t)('select_wallet'),
    onClose: closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(ConnectSection, {
        title: _unref(t)('select_format'),
        class: "px-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chainTypes, (item, index) => {
              return _createVNode(ConnectItem, {
                key: index,
                class: _normalizeClass(["mt-4 mb:mt-0 flex-1", index !== chainTypes.length - 1 ? 'mb:mr-4 ' : '']),
                active: activeChainType.value === item,
                onClick: ($event: any) => (chooseChainType(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatChainTypeDisplay)(item)), 1)
                ]),
                _: 2
              }, 1032, ["class", "active", "onClick"])
            }), 64))
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(ConnectSection, {
        title: _unref(t)('select_wallet'),
        class: "px-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletsArr), (walletArr, walletIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: walletIndex,
                class: _normalizeClass(["flex items-center justify-between flex-wrap flex-col mb:flex-row", walletIndex !== _unref(walletsArr).length - 1 ? 'mb:mb-4' : ''])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(walletArr, (wallet, index) => {
                  return (_openBlock(), _createBlock(ConnectItem, {
                    key: index,
                    class: _normalizeClass(["connect-wallet mt-4 mb:mt-0 flex-1 mb:flex-none", index !== walletArr.length - 1 ? 'mb:mr-4' : '']),
                    active: false,
                    onClick: ($event: any) => (connectWallet(wallet))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: require(`@/images/connectWallet/${wallet.img}`),
                        class: "w-6 h-6 mr-2",
                        alt: "wallet"
                      }, null, 8, _hoisted_3),
                      _createTextVNode(" " + _toDisplayString(wallet.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ], 2))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})